import { render, staticRenderFns } from "./LabelTooltip.vue?vue&type=template&id=09a592fa"
import script from "./LabelTooltip.vue?vue&type=script&lang=ts"
export * from "./LabelTooltip.vue?vue&type=script&lang=ts"
import style0 from "./LabelTooltip.vue?vue&type=style&index=0&id=09a592fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports